import * as yup from 'yup';
import { PAN_REGEX, AADHAR_REGEX, GST_REGEX, MOBILE_REGEX } from '../utils/agencyProfileConstants';
/* ---------------------------
Reusable Social URL Validator
----------------------------*/
const socialUrl = (domain, message) =>
  yup.string().nullable().test("url-validation", message, (value) => {
    if (!value) return true;
    const regex = new RegExp(`^(https?:\\/\\/)?(www\\.)?${domain}\\/.*`, "i");
    return regex.test(value);
  });

export const agencyProfileSchema = yup.object().shape({
    // Step 0: Personal
    yourName: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email required'),
    mobileNumber: yup.string().required('Mobile required'),
    alternateMobileNumber: yup.string().nullable().matches(MOBILE_REGEX, { message: 'Invalid mobile number', excludeEmptyString: true }),
    agencyName: yup.string().required('Agency Name required'),
    companyIncorporationDate: yup.date().nullable().required('Date required').max(new Date(), "Future dates not allowed"),
    countryOfResidence: yup.object().shape({
        value: yup.string().required('Country is required'),
        label: yup.string().required(),
    }).nullable().required('Country is required'), 
    specialization: yup.array().min(1, 'Select at least one specialization').required('Specialization is required'),
    website: yup.string().url('Invalid URL').nullable(),
    aboutAgency: yup.string().required('About Agency is required').min(20, 'Minimum 20 characters required'),
    gstNumber: yup.string().nullable().matches(GST_REGEX, { message: 'Invalid GST Number', excludeEmptyString: true }),
    
    panNumber: yup
        .string()
        .test(
            'pan-or-aadhar',
            'Either PAN or Aadhar is required',
            function (value) {
                const { aadharNumber } = this.parent;
                if (!value && !aadharNumber) return false;
                return true;
            }
        )
        .test(
            'pan-validation',
            'Invalid PAN Card format',
            (value) => {
                if (!value) return true; // Allow empty if Aadhar is present
                return PAN_REGEX.test(value.toUpperCase());
            }
        ),

    aadharNumber: yup
        .string()
        .test(
            'pan-or-aadhar',
            'Either PAN or Aadhar is required',
            function (value) {
                const { panNumber } = this.parent;
                if (!value && !panNumber) return false;
                return true;
            }
        )
        .test(
            'aadhar-validation',
            'Aadhar must be 12 digits',
            (value) => {
                if (!value) return true; // Allow empty if PAN is present
                return AADHAR_REGEX.test(value);
            }
        ),

    // Step 1: Address
    addressType: yup.string().required('Type required'),
    pinCode: yup.string().required('Pin Code required').matches(/^\d{6}$/, 'Pin Code must be 6 digits'),
    addressLine1: yup.string().required('Address 1 required'),
    addressLine2: yup.string().nullable(),
    state: yup.string().required('State required'),
    district: yup.string().required('District required'),

    // Step 2: Team Members
    teamMembers: yup.array().of(yup.object().shape({
        name: yup.string().required('Name required'),
        email: yup.string().email('Invalid email').required('Email required'),
        mobile: yup.string().matches(MOBILE_REGEX, 'Invalid mobile').required('Mobile required'),
        // designation: yup.string().required('Designation required'),
        designation: yup.object().shape({
            value: yup.string().required('Designation is required'), // Validate the 'value' property within the object
            label: yup.string().required(),
        }).nullable().required('Designation is required'), 
        // contactType: yup.string().required('Contact Type required'),
        contactType: yup.object().shape({
            value: yup.string().required('Contact Type is required'), // Validate the 'value' property within the object
            label: yup.string().required(),
        }).nullable().required('Contact Type is required'),
    })).min(1, 'At least one team member is required'),

    // Step 3: Social
    facebookProfileUrl: socialUrl(
    "facebook.com",
    "Enter valid Facebook URL"
  ),
    linkedinProfileUrl: socialUrl(
    "linkedin.com",
    "Enter valid LinkedIn URL"
  ),

    instagramProfileUrl: socialUrl(
    "instagram.com",
    "Enter valid Instagram URL"
  ),
    twitterProfileUrl: socialUrl(
    "x.com",
    "Enter valid Twitter URL"
  ),

    youtubeUrl:socialUrl(
    "(youtube.com|youtu.be)",
    "Enter valid YouTube URL"
  ),
   imdbUrl: socialUrl(
    "imdb.com",
    "Enter valid IMDB URL"
  ),
    whatsappNo: yup.string().nullable().matches(MOBILE_REGEX, { message: 'Invalid WhatsApp Number', excludeEmptyString: true }),
});